import React from "react";
import { useState } from "react";

// Sections
import { Frame2ByAnima } from "./sections/Frame2ByAnima";
import { HeroByAnima } from "./sections/HeroByAnima";
import { FrameByAnima } from "./sections/FrameByAnima";
import { FrameWrapperByAnima } from "./sections/FrameWrapperByAnima";
import { ElementByAnima } from "./sections/ElementByAnima";
import { DivWrapperByAnima } from "./sections/DivWrapperByAnima";
import { DivByAnima } from "./sections/DivByAnima";
import { SectionComponentNodeByAnima } from "./sections/SectionComponentNodeByAnima/SectionComponentNodeByAnima";
import { Frame1ByAnima } from "./sections/Frame1ByAnima";
import { PricingByAnima } from "./sections/PricingByAnima";
import { FotterByAnima } from "./sections/FotterByAnima";

// Custom Hook
import usePageTracking from "./sections/usePageTracking";

export const HomePage = (): JSX.Element => {
  const [activeSection, setActiveSection] = useState("");

  const handleLinkClick = (id: string) => {
    setActiveSection(id);
  };

  // Trigger the page tracking on route change
  usePageTracking();

  return (
    <div className="w-full bg-white">
      <Frame2ByAnima onLinkClick={handleLinkClick} />
      <HeroByAnima />
      <FrameByAnima />
      <FrameWrapperByAnima />
      <DivWrapperByAnima active={activeSection === "benefits"} />
      <DivByAnima />
      <ElementByAnima />
      <SectionComponentNodeByAnima />
      <Frame1ByAnima />
      <PricingByAnima />
      <FotterByAnima />
    </div>
  );
};